import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class ReservationService {
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async getCoverageReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_COVERAGE_REPORT(), params);
  }

  async downloadCoverageReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_COVERAGE_REPORT(), params);
  }

  async getSummaryReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_SUMMARY_REPORT(), params);
  }

  async downloadSummaryReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_SUMMARY_REPORT(), params);
  }
}
